import { render, staticRenderFns } from "./hecoos_lighting.vue?vue&type=template&id=650c9c0d&scoped=true"
import script from "./hecoos_lighting.vue?vue&type=script&lang=js"
export * from "./hecoos_lighting.vue?vue&type=script&lang=js"
import style0 from "./hecoos_lighting.vue?vue&type=style&index=0&id=650c9c0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c9c0d",
  null
  
)

export default component.exports